import React from "react";

/* Official Vidhya constellation mark (downward "V" — a mala of stars).
   Uses currentColor so callers control the color (lemon on indigo tiles, etc.). */
export const VidhyaMark = ({ size = 24, className, title }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 200 200"
    className={className}
    role="img"
    aria-label={title || "Vidhya"}
    fill="none"
  >
    <path d="M 60 60 L 76 90 L 89 113 L 97 127 L 100 129" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeDasharray="0.2 5.2" opacity="0.92" />
    <path d="M 140 60 L 124 90 L 111 113 L 103 127 L 100 129" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeDasharray="0.2 5.2" opacity="0.92" />
    <circle cx="60" cy="60" r="4.4" fill="currentColor" />
    <circle cx="76" cy="90" r="4.0" fill="currentColor" />
    <circle cx="89" cy="113" r="3.6" fill="currentColor" />
    <circle cx="97" cy="127" r="3.2" fill="currentColor" />
    <circle cx="140" cy="60" r="4.4" fill="currentColor" />
    <circle cx="124" cy="90" r="4.0" fill="currentColor" />
    <circle cx="111" cy="113" r="3.6" fill="currentColor" />
    <circle cx="103" cy="127" r="3.2" fill="currentColor" />
    <circle cx="100" cy="138" r="10" fill="none" stroke="currentColor" strokeWidth="3" />
    <circle cx="100" cy="138" r="4.6" fill="currentColor" />
  </svg>
);

/* Indigo squircle tile with the lemon mark inside — the in-app brand tile. */
export const VidhyaTile = ({ size = 32, radius = 10 }) => (
  <span
    style={{
      width: size, height: size, borderRadius: radius,
      background: "var(--indigo)", color: "var(--lemon)",
      display: "grid", placeItems: "center", flexShrink: 0,
    }}
    aria-hidden="true"
  >
    <VidhyaMark size={Math.round(size * 0.78)} />
  </span>
);

/* Full horizontal lockup: tile + "Vidhya" wordmark. */
export const VidhyaBrand = ({ tile = 32, font = 19, color = "var(--ink)", radius = 10, ...rest }) => (
  <span style={{ display: "flex", alignItems: "center", gap: 9 }} {...rest}>
    <VidhyaTile size={tile} radius={radius} />
    <b style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: font, letterSpacing: "-0.03em", color }}>Vidhya</b>
  </span>
);
